import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FillableForm from "./FillableForm";
import { PageLoader } from "@/_components";
import Cookies from "universal-cookie";

import { GetTemplateFileByDescription } from "../../_api/documentsApi";
import {
  declineRadioSelected,
  allRadioFieldsChecked,
  updateField,
} from "./FormHelpers";
import { Grid } from "@mui/material";

export default function ElectronicSignatureAgreement({
  handleClose,
  handleFormSaved,
  userID,
  clientID,
  jurisdictionID,
  reportID,
  vehicleID,
  appointmentID,
  formDescription,
  handleSignNowSubmit
}) {
  const cookies = new Cookies();
  const user = cookies.get("lifesaferUser");
  const [templateFile, setTemplateFile] = useState(null);
  useEffect(() => {
    if (!templateFile) {
      GetTemplateFileByDescription(
        user.languageID,
        "ElectronicSignatureAgreement"
      )
        .then((document) => {
          setTemplateFile(
            `data:application/pdf;base64,${document.fileBase64Value}`
          );
        })
        .catch((error) =>
          console.error("Error getting template file: ", error)
        );
    }
  }, []);
  return (
    <>
      {!templateFile && (
        <Grid
          container
          direction="column"
          alignItems="center"
          sx={{ marginTop: 5, paddingTop: 5 }}
        >
          <PageLoader />
        </Grid>
      )}
      {templateFile && (
        <FillableForm
          userID={userID}
          clientID={clientID}
          jurisdictionID={jurisdictionID}
          reportID={reportID}
          vehicleID={vehicleID}
          appointmentID={appointmentID}
          handleClose={handleClose}
          handleFormSaved={handleFormSaved}
          formName="ElectronicSignatureAgreement.pdf"
          formDescription={formDescription}
          templateFile={templateFile}
          handleSignNowSubmit={handleSignNowSubmit}
          validationFunction={(viewer) => {
            let declined = declineRadioSelected(viewer.formFieldCollection);
            let signatureField = viewer.formFieldCollection.find(
              (f) => f.name === "ClientSignature"
            );
            let acceptanceSelected = allRadioFieldsChecked(
              viewer.formFieldCollection
            );
            if (declined) {
              return "declined";
            } else if (signatureField.value !== "" && acceptanceSelected) {
              return true;
            } else {
              return false;
            }
          }}
          fillingFunction={(data, viewer) => {
            for (let item in data) {
              updateField(item, data[item], viewer);
            }
          }}
          fillingData={{ Date: new Date().toLocaleDateString() }}
        />
      )}
    </>
  );
}

ElectronicSignatureAgreement.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleFormSaved: PropTypes.func.isRequired,
  userID: PropTypes.number.isRequired,
  clientID: PropTypes.number.isRequired,
  jurisdictionID: PropTypes.number.isRequired,
  reportID: PropTypes.number.isRequired,
  vehicleID: PropTypes.number.isRequired,
  appointmentID: PropTypes.number.isRequired,
  formDescription: PropTypes.string.isRequired,
  handleSignNowSubmit:PropTypes.func,
};
